const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'SLA',
  description: 'This is the configuration which ignores the SLA breach once the indent reaches reported status. Detention gets calculated from reported and not truck IN',
  sortOrder: 1,
  name: 'sla',
  documentKey: 'sla',
  values: {
    sla_breach_after_24_hours: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'sla_breach_after_24_hours',
      documentKey: 'sla_breach_after_24_hours',
    },
    ignore_reported_status_for_sla_check: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'ignore_reported_status_for_sla_check',
      documentKey: 'ignore_reported_status_for_sla_check',
    },
  },
};
